import { FormRule } from 'antd';
import { ValidatorRule } from 'rc-field-form/lib/interface';

import { MAX_SCREEN_DIMENSIONS, PagesCriticalCssSettingsFormValidationSchema } from '@/modules/Pages';

// Form.List accepts only custom validators
export const screenDimensionsRules: ValidatorRule[] = [
  {
    // eslint-disable-next-line require-await
    validator: async (_, dimensions) => {
      if (!dimensions?.length) {
        throw new Error('Додайте хоча б один розмір екрану');
      }
      if (dimensions.length > MAX_SCREEN_DIMENSIONS) {
        throw new Error(`Можна додати не більше ${ MAX_SCREEN_DIMENSIONS } розмірів екрану`);
      }
    },
  },
];

export const screenDimensionWidthRules: FormRule[] = [
  { required: true, message: 'Введіть ширину' },
  { type: 'number', min: 1, message: 'Ширина повинна бути більше 0' },
];

export const screenDimensionHeightRules: FormRule[] = [
  { required: true, message: 'Введіть висоту' },
  { type: 'number', min: 1, message: 'Висота повинна бути більше 0' },
];

export const pagesCriticalCssSettingsValidationSchema: PagesCriticalCssSettingsFormValidationSchema = {
  styleFiles: [{ required: true, message: 'Оберіть хоча б один файл стилів' }],
  screenDimensions: screenDimensionsRules,
};
